import React, { useState } from 'react';
import './SendMessageSection.css';

function SendMessageSection({ isHomePage }) {
  const [form, setForm] = useState({ name: '', job: '', city: '', message: '', email: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Basic validation
    if (!form.name || !form.email || !form.message) {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3500);
      return;
    }

    setStatus('sending');
    try {
      const to = 'adityaelectroprojects@gmail.com';
      const subject = `Website enquiry from ${form.name}`;
      const bodyLines = [
        `Name: ${form.name}`,
        `Job: ${form.job || '-'} `,
        `City: ${form.city || '-'} `,
        `Email: ${form.email}`,
        '',
        `Message: ${form.message}`,
      ];
      const body = bodyLines.join('\n');

      // Try opening Gmail web compose with prefilled fields
      const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
        to
      )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}&tf=1`;

      // Open in a new tab/window so user can send via Gmail. If Gmail isn't available, fall back to mailto.
      const newWindow = window.open(gmailUrl, '_blank');
      if (!newWindow) {
        // popup blocked or failed, use mailto fallback
        const mailto = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(
          subject
        )}&body=${encodeURIComponent(body)}`;
        window.location.href = mailto;
      }

      setStatus('success');
      setForm({ name: '', job: '', city: '', message: '', email: '' });
      setTimeout(() => setStatus('idle'), 3000);
    } catch (err) {
      console.error(err);
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3500);
    }
  };

  return (
    <section className={isHomePage ? 'send-section home' : 'send-section-standalone'}>
      <div className="send-section-container">
        <div className="send-left">
          <p className="small-label">[ Contact Us ]</p>
          <h1 className="send-title">Reach Out Your Way</h1>
          <img className="contact-image" src="/images/contact.png" alt="Contact" />
          <p className="send-sub">Have more specific questions? Contact us through your preferred channel</p>
        </div>

        <div className="send-right">
          <form className="send-form" onSubmit={handleSubmit}>
            <div className="intro-line">
              <span className="big-text">Hi! I'm</span>
              <input name="name" value={form.name} onChange={handleChange} className="inline-input name" placeholder="Your Name" />
            </div>

            <div className="intro-line">
              <span className="big-text">a</span>
              <input name="job" value={form.job} onChange={handleChange} className="inline-input job" placeholder="Your Job" />
              <span className="big-text">from</span>
              <input name="city" value={form.city} onChange={handleChange} className="inline-input city" placeholder="Your City" />
              <span className="big-text">that need help. I have a question which are</span>
            </div>

            <textarea name="message" value={form.message} onChange={handleChange} className="message-box" placeholder="State your Questions here"></textarea>

            <div className="contact-line">
              <span className="big-text">You can reach me at</span>
              <input name="email" value={form.email} onChange={handleChange} className="inline-input email" placeholder="Email address" />
              <span className="big-text">to get things started.</span>
            </div>

            <div className="submit-row">
              <button className="submit-btn" type="submit" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending...' : 'Submit'}
              </button>
            </div>

            {status === 'success' && <div className="send-status success">Message sent — we'll contact you soon.</div>}
            {status === 'error' && <div className="send-status error">Please provide your name, email and message.</div>}
          </form>
        </div>
      </div>
    </section>
  );
}

export default SendMessageSection;
